/**
 * Arrow / Home / End keyboard support for ARIA tablists (WCAG 2.1.1).
 */
export function handleRovingTabKeyDown(event, index, tabs, setActiveTab, getTabElementId) {
  const { key } = event;
  if (key !== "ArrowRight" && key !== "ArrowLeft" && key !== "Home" && key !== "End") {
    return;
  }
  event.preventDefault();
  let nextIndex = index;
  if (key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
  else if (key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
  else if (key === "Home") nextIndex = 0;
  else if (key === "End") nextIndex = tabs.length - 1;

  const next = tabs[nextIndex];
  const nextId = typeof next === "string" ? next : next.id;
  setActiveTab(nextId);
  const elId =
    typeof getTabElementId === "function"
      ? getTabElementId(next)
      : `tab-${nextId}`;
  document.getElementById(elId)?.focus();
}
